import { Button } from "@mui/material";
import { EmojiEvents } from "@mui/icons-material";

interface ResultsButtonProps {
  label: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

export default function ResultsButton({
  label,
  onClick,
  disabled = false,
}: ResultsButtonProps) {
  return (
    <Button
      variant="contained"
      size="small"
      startIcon={<EmojiEvents />}
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: "primary.main",
        padding: "4px 12px",
        minHeight: "28px",
        fontSize: "0.8125rem",
        "&:hover": {
          backgroundColor: "primary.dark",
        },
        "& .MuiButton-startIcon": {
          marginRight: "4px",
          marginLeft: 0,
        },
      }}
    >
      {label}
    </Button>
  );
}

